import { createAction } from 'redux-actions'

export const WITHDRAW_RECEIVE = 'pilot/withdraw/WITHDRAW_RECEIVE'
export const receiveWithdraw = createAction(WITHDRAW_RECEIVE)
